import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';
import dataLayer from '../tracking/dataLayer';

class ShareSelect extends Controller {
  connect() {
    this.tooltipClass = 'share-tooltip';
    this.linkClass = 'share-tooltip__link';

    this.networks = [
      {
        identifier: 'linkedin',
        url: 'https://www.linkedin.com/shareArticle?mini=true&url=%URL%&summary=%TEXT%',
        icon: 'linkedin',
        maxTextLength: 256,
        text: window.app.i18n.shareOnLinkedIn,
      }, {
        identifier: 'twitter',
        url: 'https://twitter.com/intent/tweet?text=%TEXT%%20%URL%',
        icon: 'twitter',
        maxTextLength: 280,
        text: window.app.i18n.shareOnTwitter,
      },
    ];

    this.onMouseUpBound = this.onMouseUp.bind(this);

    window.addEventListener('mouseup', this.onMouseUpBound, false);
  }

  disconnect() {
    window.removeEventListener('mouseup', this.onMouseUpBound, false);
  }

  onMouseUp() {
    setTimeout(() => {
      this.removeExistingTooltip();

      if (
        !ShareSelect.hasSelection()
        || !ShareSelect.isSelectableElement(['.cms-content:not(.prevent-share)'])
      ) {
        return;
      }

      const selectionBoundingClientRect = window
        .getSelection()
        .getRangeAt(0)
        .getBoundingClientRect();

      const distanceFromTop = ShareSelect.getDistanceFromTop();

      const x = selectionBoundingClientRect.left;
      const y = selectionBoundingClientRect.top + distanceFromTop;

      this.renderTooltip(x, y);
    }, 10);
  }

  // eslint-disable-next-line class-methods-use-this
  removeExistingTooltip() {
    const tooltips = toArray(document.querySelectorAll('.js-share-tooltip'));

    tooltips.forEach((tooltip) => {
      const { parentNode } = tooltip;

      if (parentNode) {
        parentNode.removeChild(tooltip);
      }
    });
  }

  renderTooltip(x, y) {
    const tooltip = document.createElement('div');
    tooltip.className = `${this.tooltipClass} js-share-tooltip`;
    tooltip.style.left = `${x}px`;
    tooltip.style.top = `${y}px`;
    tooltip.style.position = 'absolute';
    tooltip.style.opacity = 0;
    tooltip.appendChild(this.renderTooltipContent());

    document.body.appendChild(tooltip);

    setTimeout(() => {
      tooltip.classList.add('is-visible');
    }, 10);
  }

  renderTooltipContent() {
    const wrapper = document.createElement('div');

    const url = window.location.href;
    const text = ShareSelect.selectedText();

    dataLayer.event('Select share', 'open', text.substr(0, 100));

    this.networks.forEach((network) => {
      let textForNetwork = text.substr(0, network.maxTextLength);

      if (network.identifier === 'twitter') {
        textForNetwork = text.substr(0, network.maxTextLength - url.length - 1);
      }

      const encodedText = encodeURIComponent(textForNetwork);
      const href = network.url.replace('%TEXT%', encodedText).replace('%URL%', url);

      const link = document.createElement('a');
      link.className = `${this.linkClass} ${this.linkClass}--${network.identifier} js-share-link`;
      link.href = href;
      link.target = '_blank';
      link.rel = 'nofollow noreferrer';
      link.onclick = () => {
        const windowOpenFeatures = 'height=320, width=640, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, directories=no, status=no';
        window.open(href, 'share', windowOpenFeatures);

        dataLayer.event('Select share', `share ${network.identifier}`, text.substr(0, 100));

        return false;
      };

      const span = document.createElement('span');
      span.className = 'sr-only';
      span.textContent = network.text;

      link.appendChild(span);

      wrapper.appendChild(link);
    });

    return wrapper;
  }

  static selectedText() {
    return window.getSelection().toString();
  }

  static hasSelection() {
    return !!ShareSelect.selectedText();
  }

  static getClosestElement(element, ancestor) {
    return element.closest(ancestor);
  }

  static getDistanceFromTop() {
    return (
      window.pageXOffset
      || document.documentElement.scrollTop
      || document.body.scrollTop
    );
  }

  static isSelectableElement(selectableElements) {
    const baseNode = window.getSelection().baseNode || window.getSelection().anchorNode;
    const currentSelectedElement = baseNode.parentNode;

    return selectableElements.some((ancestor) => (
      ShareSelect.getClosestElement(currentSelectedElement, ancestor)
    ));
  }
}

export default ShareSelect;
